import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import {
  setAddVZSettings,
  setCursorIconDropped,
  setVZCreationMenu,
  setVZIconClicked,
  setVZName,
} from '../../../actions/addVZephyrs';
import { ReduxState, VZephyrsConfig, Zephyr } from '../../../utils/interface';
import utilsRequest from '../../../utils/request';
import { addZephyrs } from '../../../actions/zephyrs';
import VZLimitReachedModal from './VZLimitReachedModal';
import Modal from '../../shared_components/Modal';

type Props = {
  setVZCreationMenu: Function;
  settings: {
    lat: number;
    lon: number;
    locationName: any;
  } | null;
  virtualZephyrName: string;
  setVZName: Function;
  bearerToken: string | null;
  getUserVirtualZephyrs: Function;
  addZephyrs: Function;
  setCursorIconDropped: Function;
  setAddVZSettings: Function;
  setVZIconClicked: Function;
  virtualZephyrsNumber: number;
  vZephyrsConfig: VZephyrsConfig;
};

const VZCreationMenu = ({
  setVZCreationMenu,
  settings,
  virtualZephyrName,
  setVZName,
  bearerToken,
  getUserVirtualZephyrs,
  addZephyrs,
  setCursorIconDropped,
  setAddVZSettings,
  setVZIconClicked,
  virtualZephyrsNumber,
  vZephyrsConfig,
}: Props) => {
  const [zephyrModalOpen, setZephyrModalOpen] = useState(false);
  const location = settings?.locationName?.results?.[0]?.formatted_address;
  const limitReached =
    vZephyrsConfig.active >= vZephyrsConfig.max ||
    vZephyrsConfig.new30Days >= vZephyrsConfig.new30DaysMax;

  const handleCloseVZCreationMenu = () => {
    setVZCreationMenu(false);
    setVZName('');
  };

  const handleResetConfigurations = () => {
    handleCloseVZCreationMenu();
    setCursorIconDropped(false);
    setVZIconClicked(false);
    setAddVZSettings(null);
  };

  const handleVirtualZephyrCreation = async () => {
    if (virtualZephyrName && virtualZephyrName.trim().length > 0 && settings) {
      if (limitReached) {
        setZephyrModalOpen(true);
        return;
      }
      const res = await utilsRequest.addVZephyr(
        virtualZephyrName,
        virtualZephyrName,
        settings.lon,
        settings.lat,
        bearerToken,
      );

      if (res) {
        const virtualZephyrs = await getUserVirtualZephyrs(
          localStorage.getItem('isPublic'),
        );
        const vZephyrToAdd = virtualZephyrs.find(
          (vz: Zephyr) =>
            vz.name === virtualZephyrName &&
            String(vz.latitude) === String(settings.lon) &&
            String(vz.longitude) === String(settings.lat),
        );
        if (virtualZephyrs && vZephyrToAdd) {
          addZephyrs([vZephyrToAdd]);
          handleResetConfigurations();
        }
      }
    }
  };

  const handleUpdateVZName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setVZName(event.target.value);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        borderRadius: 6,
        background: '#222539',
        boxShadow:
          '0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: '16px',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 10,
          alignSelf: 'stretch',
          borderBottom: '1px solid var(--Color-esNavy-300, #65677D)',
        }}
      >
        <p style={{ margin: 0, color: '#fff' }}>
          Add Virtual Zephyr ({virtualZephyrsNumber}/{vZephyrsConfig.max})
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          style={{ cursor: 'pointer' }}
          onClick={handleResetConfigurations}
        >
          <path
            d="M16 15.1669L20.6669 10.5L22 11.8331L17.3331 16.5L22 21.1669L20.6669 22.5L16 17.8331L11.3331 22.5L10 21.1669L14.6669 16.5L10 11.8331L11.3331 10.5L16 15.1669Z"
            fill="white"
          />
        </svg>
      </div>

      <div
        style={{
          display: 'flex',
          padding: 24,
          flexDirection: 'column',
          alignItems: 'center',
          gap: 41,
          flex: '1 0 0',
          alignSelf: 'stretch',
        }}
      >
        <div style={{ width: '100%' }}>
          <p
            style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#fff' }}
          >
            Virtual Zephyr
          </p>
          <input
            type="text"
            placeholder="Name"
            style={{
              borderRadius: 4,
              background: '#343852',
              height: 40,
              color: '#fff',
              border: 'none',
              fontWeight: 400,
            }}
            onChange={handleUpdateVZName}
          />
        </div>
        <div style={{ width: '100%' }}>
          <p
            style={{
              margin: '0 0 8px 0',
              fontSize: 14,
              fontWeight: 600,
              color: '#fff',
            }}
          >
            Location
          </p>
          <p
            style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#fff' }}
          >
            {location ?? 'No information'}
          </p>
        </div>
        <div style={{ width: '100%' }}>
          <p
            style={{
              margin: 0,
              fontSize: 14,
              fontWeight: 400,
              textAlign: 'center',
              color: '#AFB1C7',
            }}
          >
            Virtual Zephyrs will take approximately 1 hour to initialise.{' '}
          </p>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '16px',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 10,
          alignSelf: 'stretch',
          borderTop: '1px solid var(--Color-esNavy-300, #65677D)',
        }}
      >
        <button
          type="button"
          className="prompt-button"
          style={{
            width: 'auto',
            height: 40,
            padding: '0 12px',
            background: 'transparent',
          }}
          onClick={handleResetConfigurations}
        >
          Cancel
        </button>
        <button
          type="button"
          className="prompt-button"
          style={{ width: 'auto', height: 40, padding: '0 12px' }}
          onClick={handleVirtualZephyrCreation}
        >
          Add
        </button>
      </div>
      <Modal
        on={zephyrModalOpen}
        modalComponent={
          <VZLimitReachedModal
            setZephyrModalOpen={setZephyrModalOpen}
            vZephyrsConfig={vZephyrsConfig}
          />
        }
      />
    </div>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  settings: state.addVZephyrs.settings,
  virtualZephyrName: state.addVZephyrs.virtualZephyrName,
  bearerToken: state.auth.bearerToken,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setVZCreationMenu,
      setVZName,
      addZephyrs,
      setCursorIconDropped,
      setAddVZSettings,
      setVZIconClicked,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(VZCreationMenu);
